import { RadioStyleType } from './radio-style.interface';
import { RadioDarkTheme } from './radio.dark-theme';

export const RadioLightTheme: RadioStyleType = RadioDarkTheme;
